module.exports = __webpack_public_path__ + "static/media/face6.a5b01848.jpg";